import { Location } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ng-refunds-help',
  templateUrl: './refunds-help.component.html',
  styleUrls: ['./refunds-help.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RefundsHelpComponent {

  constructor(private location: Location) { }

  /**
   * Go Back
   *
   * @summary Navigate Back
   * @return void
   */
  back(): void {
    this.location.back();
  }

}
